import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { distinctUntilChanged, tap } from 'rxjs/operators';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { OfflineService } from '../../services/offline.service';

@UntilDestroy()
@Component({
    selector: 'app-offline-notifier',
    templateUrl: './offline-notifier.component.html',
    styleUrls: ['./offline-notifier.component.scss'],
    standalone: false
})
export class OfflineNotifierComponent {

  @ViewChild('connectionLost') connectionLostTemplate;

  duration = 5.0;
  horizontalPosition: MatSnackBarHorizontalPosition = 'start';
  verticalPosition: MatSnackBarVerticalPosition = 'bottom';

  constructor(private offlineService: OfflineService, private snackbarRef: MatSnackBar) {
    this.offlineService.networkStatus.pipe(
      distinctUntilChanged(),
      tap((isOnline: boolean) => {
        if (!isOnline) {
          this.showNotification('Network connection lost', '', this.duration);
        }
      }),
      untilDestroyed(this)
    ).subscribe();
  }

  showNotification(msg: string, description: string, duration: number) {
    /* this.snackbarRef.openFromTemplate(this.connectionLostTemplate, {
      duration: 1000000,
    }); */
    if (!duration) {
      duration = this.duration;
    }
    this.snackbarRef.open(msg, description, {
      duration: duration * 1000,
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
    });
  }
}
